import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/$org/billing/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      href: `/${encodeURIComponent(params.org)}/billing/overview`,
    });
  },
});
